import React, { useEffect } from 'react'
import { DropdownItem } from './DropdownItem'
import { useNavigate } from 'react-router-dom'
import DropdownSelect, { DropdownSelectProps } from './DropdownSelect'
import { useQuery } from '../../hooks/useQuery'

const RoutedDropdownSelect = <T extends readonly DropdownItem[]>({
    defaultItem,
    onChange,
    routingParam,
    ...props
}: Omit<DropdownSelectProps, 'items' | 'selectedItems' | 'multiple' | 'onChange'> & {
    defaultItem: T[number]['id']
    items: T
    onChange?: (value: T[number]['id']) => void
    routingParam: string
}) => {
    const query = useQuery()
    const navigate = useNavigate()
    const selectedItem = props.items.find((i) => i.id === query.get(routingParam))?.id || defaultItem

    useEffect(() => {
        if (!query.get(routingParam)) {
            query.set(routingParam, defaultItem)
        }

        void navigate(`?${query.toString()}`, { replace: true })
    }, [query, navigate, defaultItem, routingParam])

    const handleChange = ([item]: string[]) => {
        query.set(routingParam, item)
        navigate('?' + query.toString())

        if (onChange) onChange(item)
    }

    return <DropdownSelect onChange={handleChange} selectedItems={[selectedItem]} {...props} />
}

export default RoutedDropdownSelect
